export default "__VITE_ASSET__DBI65MVO__"